import { Feature } from '@wwt/entities/search-response'

import { getIntegrationOrWwtPriority } from './getIntegrationOrWwtPriority.ts'

/**
 * Used to get priority of feature
 *
 * @param feature - input feature
 * @param optionPriority {number}:
 * * If 0, sort by feature priority
 * * If 1, sort by selected option priority if exists, otherwise sort by feature priority
 * * If 2, sort by selected option priority if exists, otherwise return -1
 *
 * @returns priority of feature or -1 if feature/option is undefined
 *
 * @author Vladyslav Vladinov, Ivan Shchedrovskyi
 */
export const getFeaturePriority = (
	feature: Feature | undefined,
	optionPriority: 0 | 1 | 2 = 1
) => {
	const DEFAULT_PRIORITY = -1

	if (!feature) {
		return DEFAULT_PRIORITY
	}

	const selectedOption =
		'options' in feature
			? feature.options?.find(option => option.isSelected)
			: feature.option

	if (!selectedOption) {
		throw new Error('selectedOption must always exist')
	}

	if (optionPriority === 1 || optionPriority === 2) {
		const hasPriority =
			selectedOption.wwtPriority !== undefined ||
			selectedOption.integrationPriority !== undefined

		if (optionPriority === 2 && !hasPriority) {
			return DEFAULT_PRIORITY
		}

		if (hasPriority) {
			return getIntegrationOrWwtPriority(selectedOption, DEFAULT_PRIORITY)
		}
	}

	return getIntegrationOrWwtPriority(feature, DEFAULT_PRIORITY)
}
